import { PageHeader } from '../components/common';

/**
 * Página placeholder pras obrigações fiscais ainda não implementadas.
 * Mostra o que a tela vai fazer quando estiver pronta, mantendo o roadmap
 * visível no sidebar sem quebrar a UX (não é só um "404 — em breve").
 */
export default function EmConstrucao({ titulo, sub, descricao, proximoPasso }) {
  return (
    <>
      <PageHeader title={titulo} sub={sub} />

      <div className="card" style={{
        padding: '40px 32px',
        borderLeft: '3px solid var(--gold)',
        maxWidth: 760,
      }}>
        <div style={{
          display: 'inline-block',
          fontFamily: 'var(--font-data)',
          fontSize: 10,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          color: 'var(--gold)',
          background: 'var(--gold-pale)',
          border: '1px solid var(--gold-glow)',
          padding: '4px 10px',
          borderRadius: 99,
          marginBottom: 20,
        }}>
          ⚙ Em construção
        </div>

        <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 18,
          fontWeight: 600,
          marginBottom: 12,
          letterSpacing: '-0.01em',
        }}>
          O que esta tela vai entregar
        </h2>

        <p style={{
          fontSize: 14,
          lineHeight: 1.6,
          color: 'var(--text-secondary)',
          marginBottom: 24,
        }}>
          {descricao}
        </p>

        <div style={{
          padding: 16,
          background: 'var(--surface-2)',
          borderRadius: 'var(--radius)',
          borderLeft: '2px solid var(--gold)',
        }}>
          <div style={{
            fontSize: 10,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.10em',
            color: 'var(--gold)',
            marginBottom: 6,
          }}>
            Próximo passo de implementação
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.5 }}>
            {proximoPasso}
          </div>
        </div>

        <div style={{
          marginTop: 28,
          paddingTop: 20,
          borderTop: '1px solid var(--border)',
          fontSize: 11,
          color: 'var(--text-muted)',
          lineHeight: 1.5,
        }}>
          Esta tela faz parte do roadmap fiscal do <strong style={{ color: 'var(--gold)' }}>Átrio Contábil</strong>.
          Os módulos da seção Fiscal serão entregues em sequência conforme as obrigações forem mapeadas
          (apurações → SPED Contribuições → declarações acessórias).
        </div>
      </div>
    </>
  );
}
